<div class="referral-container position-relative d-flex flex-column h-100">
  <div class="d-flex flex-column bgcomp h-100 px-3 py-3">
    <div mat-dialog-title class="d-flex mb-1">
      <h2
        id="dialog-title"
        class="drag-handle-header text-center flex-grow-1"
        cdkDrag
        cdkDragRootElement=".draggable-dialog-container.referral-dialog"
        cdkDragBoundary=".cdk-overlay-container"
        cdkDragHandle
      >
        Referral Details
      </h2>
    </div>
    <mat-dialog-content
      class="view-mode custom-scrollbar overflow-auto m-0 p-0"
      #dialogContentScrollArea
    >
      <div class="row no-gutters">
        <div class="col pr-3">
          <div class="referral-section overflow-hidden h-100 p-3">
            <h4
              id="section-caller-details"
              class="form-label text-center text-capitalize mb-3"
            >
              <div>Caller Details</div>
            </h4>
            <div class="section-content">
              <div class="row justify-content-center no-gutters my-2">
                <div class="everlabel inline-editable-label">Site Name</div>
                <div
                  id="site-name"
                  class="everlabel inline-editable-label contents"
                >
                  {{ currentReferral?.siteName }}
                </div>
              </div>
              <div class="row justify-content-center no-gutters my-2">
                <div class="everlabel inline-editable-label">
                  Clinician's Surname
                </div>
                <div
                  id="clinician-name"
                  class="everlabel inline-editable-label contents"
                >
                  {{ currentReferral?.referrerName }}
                </div>
              </div>
              <div class="row justify-content-center no-gutters my-2">
                <div class="everlabel inline-editable-label">
                  Clinician's Phone
                </div>
                <div
                  id="clinician-phone"
                  class="everlabel inline-editable-label contents"
                >
                  {{ currentReferral?.referrerPhone }}
                </div>
              </div>
              <div class="row justify-content-center no-gutters my-2">
                <div class="everlabel inline-editable-label">
                  Authority to request scans
                </div>
                <mat-radio-group
                  id="authority-to-request-scans"
                  class="label-no-margin editor d-flex justify-content-start align-items-center py-2"
                  [disabled]="true"
                  [value]="currentReferral?.confirmation"
                  aria-label="Authority to request scans"
                >
                  <mat-radio-button
                    class="flex-grow-1 pl-1"
                    [value]="true"
                    tabIndex="0"
                    >Yes</mat-radio-button
                  >
                  <mat-radio-button
                    class="flex-grow-1"
                    [value]="false"
                    tabIndex="0"
                    >No</mat-radio-button
                  >
                </mat-radio-group>
              </div>
              <div
                class="row justify-content-center no-gutters my-2"
                *ngIf="currentReferral?.confirmation !== true"
              >
                <div class="everlabel inline-editable-label">Approved By</div>
                <div
                  id="approved-by"
                  class="everlabel inline-editable-label contents"
                >
                  {{ currentReferral?.approvedByDoctor }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col pr-3">
          <div class="referral-section overflow-hidden h-100 p-3">
            <h4
              id="section-patient-details"
              class="form-label text-center text-capitalize mb-3"
            >
              <div>Patient Details</div>
            </h4>
            <div class="section-content">
              <div class="row justify-content-center no-gutters my-2">
                <div class="everlabel inline-editable-label">
                  Hospital Number
                </div>
                <div
                  id="hospital-number"
                  class="everlabel inline-editable-label contents"
                >
                  {{ currentReferral?.patient?.patientExternalId }}
                </div>
              </div>
              <div class="row justify-content-center no-gutters my-2">
                <div class="everlabel inline-editable-label">Surname</div>
                <div
                  id="patient-surname"
                  class="everlabel inline-editable-label contents"
                >
                  {{ currentReferral?.patient?.lastName }}
                </div>
              </div>
              <div class="row justify-content-center no-gutters my-2">
                <div class="everlabel inline-editable-label">Given Name(s)</div>
                <div
                  id="patient-given-names"
                  class="everlabel inline-editable-label contents"
                >
                  {{ currentReferral?.patient?.firstName }}
                </div>
              </div>
              <div class="row justify-content-center no-gutters my-2">
                <div class="everlabel inline-editable-label">Date of Birth</div>
                <div
                  id="patient-birth-date"
                  class="everlabel inline-editable-label contents"
                >
                  {{
                    displayDate(
                      currentReferral?.patient?.dateOfBirth || '',
                      false
                    )
                  }}
                </div>
              </div>
              <div class="row justify-content-center no-gutters">
                <div class="everlabel inline-editable-label">
                  Patient Location
                </div>
                <div
                  id="patient-location"
                  class="everlabel inline-editable-label contents"
                >
                  {{ currentReferral?.patient?.location }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-2 referral-side-panel-min-width">
          <div
            class="referral-section d-flex flex-column overflow-hidden h-100 px-3 pt-3"
          >
            <div class="d-flex mt-1">
              <div
                id="status-badge"
                class="referral-status-badge m-0"
                [ngClass]="{ acknowledged: isAcknowledged() }"
              >
                {{
                  currentReferral
                    ? statusDisplayMapping.get(currentReferral.status)
                    : ''
                }}
              </div>
            </div>
            <hr
              class="primary-divider w-100 my-3"
              [ngClass]="{
                'urgent-sst': currentReferral?.urgency === 'SST'
              }"
            />
            <div class="section-content">
              <div class="d-flex">
                <div>Time Since Call Started:</div>
                <div id="info-time-since-call" class="ml-2">
                  {{ timeSinceCall$ | async }}
                </div>
              </div>
              <div class="d-flex">
                <div class="flex-shrink-0">Time Created:</div>
                <div id="info-time-created" class="ml-2">
                  {{ displayDate(currentReferral?.processInitiatedAt, true) }}
                </div>
              </div>
              <ng-container *ngIf="latestDecision">
                <div class="pt-2 dash-border-bottom"></div>
                <div class="pt-2 d-flex">
                  <div class="flex-shrink-0">Decision At:</div>
                  <div id="info-decision-at" class="ml-2">
                    {{ displayDate(latestDecision?.decidedAt, true) }}
                  </div>
                </div>
                <div class="d-flex">
                  <div class="flex-shrink-0">Decision By:</div>
                  <div id="info-decision-by" class="ml-2">
                    {{ displayDecisionBy(latestDecision?.decidedBy) }}
                  </div>
                </div>
                <div class="d-flex" *ngIf="latestDecision?.gmc">
                  <div class="flex-shrink-0 text-right">GMC:</div>
                  <div id="info-gmc" class="ml-2">
                    {{ latestDecision?.gmc }}
                  </div>
                </div>
                <div class="d-flex" *ngIf="latestDecision?.imc">
                  <div class="flex-shrink-0">MCIRL:</div>
                  <div id="info-imc" class="ml-2">
                    {{ latestDecision?.imc }}
                  </div>
                </div>
              </ng-container>
            </div>
          </div>
        </div>
      </div>
      <div class="row no-gutters mt-3">
        <div class="col pr-3">
          <div class="referral-section h-100 p-3">
            <ng-container
              *ngIf="!ReferralsUtility.shouldShowTeamsProtocol(latestDecision)"
            >
              <h4
                id="section-patient-medical-history"
                class="form-label text-center text-capitalize mb-3"
              >
                Patient Medical History
              </h4>
              <div class="row">
                <div class="col-6">
                  <div class="everlabel">Differential Diagnosis</div>
                  <div id="differential-diagnosis" class="contents pre-line">
                    {{ currentReferral?.differentialDiagnosis }}
                  </div>

                  <div class="everlabel">Clinical Notes</div>
                  <div id="clinical-notes" class="contents pre-line">
                    {{ getClinicalNotesForDisplay() }}
                  </div>
                </div>
                <div class="col-6">
                  <div class="d-flex align-items-center my-2">
                    <div class="everlabel inline-editable-label">Pregnancy</div>
                    <div id="pregnancy" class="contents everlabel">
                      {{ displayPregnancyStatus(currentReferral?.pregnancy) }}
                    </div>
                  </div>
                  <div class="d-flex align-items-center my-2">
                    <div class="everlabel inline-editable-label">
                      Contrast Allergy
                    </div>
                    <div id="contrast-allergy" class="contents everlabel">
                      {{ currentReferral?.contrastAllergy }}
                    </div>
                  </div>
                  <div class="d-flex align-items-center my-2">
                    <div class="everlabel-long inline-editable-label">
                      Paediatric Consultation
                    </div>
                    <div
                      id="paediatric-consultation"
                      class="contents everlabel-long"
                    >
                      {{
                        currentReferral?.hasPriorPaediatricConsultation
                          ? 'Yes'
                          : 'No'
                      }}
                    </div>
                  </div>
                  <div class="d-flex align-items-center my-2">
                    <div class="everlabel inline-editable-label">
                      eGFR Result
                    </div>
                    <div id="egfr-result" class="contents everlabel">
                      {{ latestDecision?.egfrResult }}
                    </div>
                  </div>
                </div>
              </div>
            </ng-container>
          </div>
        </div>
        <div class="col pr-3">
          <div class="referral-section overflow-hidden h-100 p-3">
            <h4
              id="section-scan-protocol"
              class="form-label text-center text-capitalize mb-3"
            >
              {{
                ReferralsUtility.shouldShowTeamsProtocol(latestDecision)
                  ? 'Scan Protocol Notes'
                  : 'Regions for Scanning'
              }}
            </h4>
            <div
              class="section-content"
              *ngIf="
                !ReferralsUtility.shouldShowTeamsProtocol(latestDecision);
                else showTeamsProtocol
              "
            >
              <div class="scan-container mb-4">
                <table
                  *ngIf="staticDecisionItemList"
                  id="table-decision-items"
                  class="padded-cells border-transparent transparent-table w-100"
                  aria-label="Approved Regions for Scanning"
                >
                  <thead
                    class="unemphasised-headers dash-border-bottom pb-1 mb-2"
                  >
                    <th>Modality</th>
                    <th>Body Part/Procedure</th>
                    <th>Contrast</th>
                    <th>Scan Protocol Notes</th>
                  </thead>
                  <tbody>
                    <tr
                      *ngFor="
                        let decisionItem of staticDecisionItemList;
                        index as ind
                      "
                      class="contents"
                    >
                      <td>{{ decisionItem.modality }}</td>
                      <td>{{ decisionItem.bodyPart }}</td>
                      <td>{{ decisionItem.phaseOfContrast }}</td>
                      <td class="pre-line">{{ decisionItem.scanNotes }}</td>
                    </tr>
                  </tbody>
                </table>
                <table
                  *ngIf="staticReferralItemList"
                  id="table-referral-items"
                  class="padded-cells border-transparent transparent-table w-100"
                  aria-label="Original Regions for Scanning"
                >
                  <thead
                    class="unemphasised-headers dash-border-bottom pb-1 mb-2"
                  >
                    <th>Modality</th>
                    <th>Body Part/Procedure</th>
                  </thead>
                  <tbody>
                    <tr
                      *ngFor="
                        let referralItem of staticReferralItemList;
                        index as ind
                      "
                      class="contents"
                    >
                      <td>{{ referralItem.modality }}</td>
                      <td>{{ referralItem.bodyPart }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="d-flex">
                <div class="everlabel-half inline-editable-label">
                  Polytrauma
                </div>
                <mat-radio-group
                  class="label-no-margin d-flex justify-content-start align-items-center flex-grow-1 py-2"
                  id="is-trauma"
                  [disabled]="true"
                  [value]="currentReferral?.isTrauma"
                  aria-label="Polytrauma Checkbox"
                >
                  <mat-radio-button
                    class="col-4 px-0"
                    [value]="true"
                    tabIndex="0"
                    >Yes</mat-radio-button
                  >
                  <mat-radio-button
                    class="col-4 px-0"
                    [value]="false"
                    tabIndex="0"
                    >No</mat-radio-button
                  >
                </mat-radio-group>
              </div>
              <div class="d-flex">
                <div class="everlabel-half inline-editable-label">Stroke</div>
                <div class="flex-grow-1">
                  <mat-radio-group
                    class="label-no-margin d-flex justify-content-start align-items-center flex-grow-1 py-2"
                    id="is-stroke"
                    [disabled]="true"
                    [value]="isStroke"
                    aria-label="Polytrauma Checkbox"
                  >
                    <mat-radio-button
                      class="col-4 px-0"
                      [value]="true"
                      tabIndex="0"
                      >Yes</mat-radio-button
                    >
                    <mat-radio-button
                      class="col-4 px-0"
                      [value]="false"
                      tabIndex="0"
                      >No</mat-radio-button
                    >
                  </mat-radio-group>
                </div>
              </div>
            </div>
            <ng-template #showTeamsProtocol>
              <div id="notes-for-reporting-rad-readonly" class="pre-line">
                {{ latestDecision.notesForReportingRadiologist }}
              </div>
            </ng-template>
          </div>
        </div>
        <div class="col-2 referral-side-panel-min-width position-relative">
          <div class="d-flex flex-column w-100 h-100">
            <div
              class="referral-section overflow-hidden flex-grow-1 p-3"
              *ngIf="!!this.latestDecision?.reason || isDeferred"
            >
              <div class="section-content d-flex flex-column overflow-hidden">
                <div *ngIf="!!this.latestDecision?.reason" class="pb-3">
                  <div>
                    {{
                      hasDeclinedReason
                        ? 'Reason for declining:'
                        : 'Notes From Radiologist:'
                    }}
                  </div>
                  <div
                    id="reason-for-declining"
                    class="custom-scrollbar overflow-auto pl-2"
                  >
                    {{ latestDecision?.reason }}
                  </div>
                </div>
                <div *ngIf="isDeferred" class="pb-3">
                  <div>Reason for deferral:</div>
                  <div
                    id="reason-for-deferral"
                    class="custom-scrollbar overflow-auto pl-2"
                  >
                    {{ currentReferral?.reasonForDeferral }}
                  </div>
                </div>
              </div>
            </div>
            <div class="d-flex justify-content-center mt-auto pt-3 pb-3">
              <button
                *ngIf="isReferralAcknowledgable()"
                mat-stroked-button
                id="acknowledge-btn"
                class="mr-2"
                (click)="acknowledge()"
                [disabled]="actionInProgress"
                type="button"
                tabIndex="0"
              >
                <ng-container *ngIf="!actionInProgress">
                  Acknowledge
                </ng-container>
                <mat-spinner
                  *ngIf="actionInProgress"
                  id="action-spinner"
                  diameter="24"
                  >Loading...</mat-spinner
                >
              </button>
              <button
                *ngIf="isDeferrable"
                mat-stroked-button
                id="defer-btn"
                class="mr-2"
                (click)="defer()"
                [disabled]="actionInProgress"
                type="button"
                tabIndex="0"
              >
                <ng-container *ngIf="!actionInProgress"> Defer </ng-container>
                <mat-spinner
                  *ngIf="actionInProgress"
                  id="action-spinner"
                  diameter="24"
                  >Loading...</mat-spinner
                >
              </button>
              <button
                mat-stroked-button
                id="close"
                (click)="closeForm()"
                class="plain-button"
                [disabled]="actionInProgress"
                type="button"
                tabIndex="0"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </mat-dialog-content>
  </div>
  <div
    *ngIf="hasPendingChanges() && !actionInProgress"
    class="floating-notification clickable alert"
    (click)="loadPendingChanges()"
  >
    <fa-icon class="pr-2" [icon]="['fas', 'info-circle']"></fa-icon>
    This referral has been modified since you opened it. Please click here to
    refresh.
  </div>
</div>
